<template>
  <div
    v-if="isLoading"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
    }"
  >
    <svg :height="props.size" viewBox="10 10 100 100" :width="props.size">
      <path
        class="background-arc"
        :class="isCtaType ? 'fill-light-gray' : 'fill-primary-10'"
        d="M60,92.4c17.9,0,32.4-14.5,32.4-32.4S77.9,27.6,60,27.6S27.6,42.1,27.6,60S42.1,92.4,60,92.4z M60,96
	c19.9,0,36-16.1,36-36c0-19.9-16.1-36-36-36c-19.9,0-36,16.1-36,36C24,79.9,40.1,96,60,96z"
      />
      <path
        class="colored-arc"
        :class="isCtaType ? 'stroke-primary-80' : 'stroke-brand-deep-yellow'"
        d="M60,25.8c0,0,14.6-1,25.2,11.1c10.6,12.1,9,25.3,9,25.3"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isCtaType?: boolean
    isLoading?: boolean
    size?: number
  }>(),
  {
    isLoading: false,
    size: 30,
    isCtaType: false,
  },
)
</script>

<style scoped>
svg {
  animation: infinite rotate 1s linear;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(300deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.background-arc {
  fill-rule: evenodd;
}
.colored-arc {
  @apply fill-none stroke-4 stroke-cap-round;
}
</style>
